import { useEffect, useState } from "react";
import ComponentCard from "../../../components/common/ComponentCard";
import Button from "../../../components/ui/button/Button";
import Label from "../../../components/form/Label";
import Input from "../../../components/form/input/InputField";
import Form from "../../../components/form/Form";
import Select from "../../../components/form/Select";
import { useLocation, useNavigate } from "react-router";

const apiUrl = process.env.REACT_APP_API_URL;

export default function AddNewHeading() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    orderlevel: "",
    status: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    orderlevel: "",
    status: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const handleSelectChange = (option: any) => {
    setFormData({
      ...formData,
      status: option,
    });
    setErrors({
      ...errors,
      status: "",
    });
  };

  const validate = () => {
    let newErrors: any = {};
    if (!formData.name.trim()) newErrors.name = "Heading name is required";
    if (!formData.orderlevel.trim()) newErrors.orderlevel = "Display order is required";
    if (!formData.status) newErrors.status = "Record status is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/headings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        navigate("/headings");
      } else {
        alert("Error submitting form");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const handleCancel = () => {
    navigate("/headings");
  };

  return (
    <>
      <ComponentCard title="Add New Heading">
        <Form onSubmit={handleSubmit}>
          <>
            <div className="grid gap-6">
              <div className="col-span-full">
                <h4 className="pb-4 text-base font-medium text-gray-800 border-b border-gray-200 dark:border-gray-800 dark:text-white/90">
                  Heading
                </h4>
              </div>

              {/* Heading Name */}
              <div>
                <Label>Heading Name</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
              </div>

              {/* Display Order */}
              <div>
                <Label>Display Order</Label>
                <Input
                  type="text"
                  id="orderlevel"
                  name="orderlevel"
                  value={formData.orderlevel}
                  onChange={handleChange}
                />
                {errors.orderlevel && <p className="text-red-500 text-sm">{errors.orderlevel}</p>}
              </div>

              {/* Record Status */}
              <div>
                <Label>Record Status</Label>
                <Select
                  options={[
                    { value: "current", label: "Current" },
                    { value: "non-current", label: "Non-Current" },
                  ]}
                  onChange={handleSelectChange}
                  className="mt-2 bg-gray-50 dark:bg-gray-800"
                />
                {errors.status && <p className="text-red-500 text-sm">{errors.status}</p>}
              </div>

              <div className="flex gap-3">
                <Button size="sm" type="submit">
                  Save Changes
                </Button>
                <Button size="sm" variant="outline" onClick={handleCancel}>
                  Cancel
                </Button>
              </div>
            </div>
          </>
        </Form>
      </ComponentCard>
    </>
  );
}
